import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Signal } from '@angular/core';
import { Params, QueryParamsHandling, RouterLink } from '@angular/router';

import { CypressTagDirective } from '@vlaio/cypress/core';

import { VlaioIconComponent } from '../../icon';
import { VlaioButtonAbstractComponent } from '../shared';

@Component({
	selector: 'vlaio-internal-button',
	templateUrl: 'internal-button.component.html',
	styleUrls: ['./internal-button.component.scss', '../shared/button-variants.scss'],
	standalone: true,
	imports: [NgClass, RouterLink, CypressTagDirective, VlaioIconComponent, CypressTagDirective],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VlaioInternalButtonComponent extends VlaioButtonAbstractComponent {
	/**
	 * The link to navigate to.
	 *
	 * If the property {@link isDisabled} is set to `true`,
	 * navigation will be blocked.
	 */
	public link: Signal<string | string[]> = input.required();

	/**
	 * The fragments (parameters) to be added to the URL query.
	 */
	public linkQueryParams: Signal<Params> = input();

	/**
	 * How to handle query parameters in the URL.
	 *
	 * Default value is ``, which means the params will be overwritten.
	 */
	public linkQueryParamsHandling: Signal<QueryParamsHandling> = input('');

	/**
	 * Allow the button to has its content centered or spread (spaced-between). This input
	 * was added to allow the button layout to change without the need for `::ng-deep`. This
	 * will only have an effect if the `fullWidth` is set to `true`.
	 *
	 * Default value is `centered`.
	 *
	 * Note: This cannot be added to the Abstract, because the `layout` is not used in the
	 * external button.
	 */
	public layout: Signal<'centered' | 'spread'> = input('centered');
}
